module.exports = __webpack_public_path__ + "img/repair_active.9407324d.svg";